import type { PopoverProps } from '@nuxt/ui';
import type { MaybeRefOrGetter } from 'vue';
import { toValue } from 'vue';
import { preventOutsideDismissWithinMenu } from '#layers/ui/components/NestedSelectMenu/utils';
import { isInsideOtherPopper } from '#layers/ui/utils/reka-popper';

/**
 * A folded switcher's own popover teleports to `<body>`, so its clicks read as outside the `…` panel
 * and would dismiss it; the guards keep `…` open while interaction stays inside that child popover.
 */
export function useEllipsisPopover(contentRef: MaybeRefOrGetter<HTMLElement | null>) {
	function guardNestedPopoverDismiss(event: Event) {
		preventOutsideDismissWithinMenu(event, (target) => isInsideOtherPopper(target, toValue(contentRef)));
	}

	const ellipsisContent: PopoverProps['content'] = {
		side: 'bottom',
		align: 'start',
		onPointerDownOutside: guardNestedPopoverDismiss,
		onFocusOutside: guardNestedPopoverDismiss,
		onInteractOutside: guardNestedPopoverDismiss,
	};

	return { ellipsisContent };
}
